import classNames from 'classnames';
import styles from './ContactCard.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';

export interface UI_ContactProps {
	className?: string;
	heading?: string;
	telephone?: string;
	email?: string;
}

export const UI_ContactCard: React.FC<UI_ContactProps> = ({ className, heading, telephone, email }) => (
	<div className={classNames(styles.ContactCard, className)}>
		<div className={styles.ContactCard_textbox}>
			{heading && (
				<UI_Heading headingLevel="h6" style="xs" className={styles.ContactCard_heading}>
					{heading}
				</UI_Heading>
			)}
			<div className={styles.ContactCard_text}>
				{telephone && (
					<UI_Link style="sm" href={`tel:${telephone}`}>
						{telephone}
					</UI_Link>
				)}
				{email && (
					<UI_Link style="sm" href={`mailto:${email}`}>
						{email}
					</UI_Link>
				)}
			</div>
		</div>
	</div>
);
